import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallStar = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("g", {
                    clipPath: "url(#clip0_4830_9761)",
                    children: /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.01681 1.15905C6.2817 0.616866 6.92844 0.410611 7.45405 0.647614C7.68135 0.75011 7.87076 0.928828 7.98324 1.15905L9.45088 4.16295L12.7693 4.64967C13.343 4.73383 13.7846 5.26508 13.6868 5.88054C13.6505 6.10887 13.5413 6.31628 13.3799 6.47525L10.9616 8.8566L11.5284 12.1963C11.6327 12.8108 11.1965 13.3468 10.6233 13.4366C10.3884 13.4734 10.1461 13.4337 9.93433 13.3212L7.00002 11.7628L4.06571 13.3212C3.55518 13.5924 2.89824 13.4254 2.59881 12.905C2.47596 12.6916 2.43002 12.4415 2.47163 12.1963L3.0385 8.8566L0.620137 6.47525C0.1854 6.04716 0.195117 5.3505 0.639422 4.93407C0.804171 4.77966 1.01142 4.68184 1.23075 4.64967L4.54917 4.16295L6.01681 1.15905Z",
                        fill: "currentColor"
                    })
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_4830_9761",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("g", {
                    clipPath: "url(#clip0_4803_11604)",
                    children: /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.35424 1.46631L8.98395 4.80193L12.6677 5.34224C12.8813 5.37358 13.0281 5.56538 12.9955 5.77064C12.9831 5.84827 12.9458 5.92024 12.8887 5.97644L10.2103 8.61388L10.8382 12.3135C10.873 12.5184 10.7283 12.7116 10.515 12.745C10.4283 12.7586 10.3395 12.7438 10.2626 12.703L6.99997 10.9701L3.73732 12.703C3.54816 12.8035 3.31004 12.7376 3.20547 12.5559C3.163 12.4821 3.14758 12.3967 3.16171 12.3135L3.78965 8.61388L1.11123 5.97644C0.960295 5.82782 0.963354 5.58979 1.11806 5.44479C1.17657 5.38995 1.25148 5.35409 1.33229 5.34224L5.01599 4.80193L6.6457 1.46631C6.73754 1.27835 6.9706 1.19749 7.16626 1.28571C7.24894 1.323 7.31544 1.38688 7.35424 1.46631Z",
                        stroke: "currentColor",
                        strokeWidth: "1.4"
                    })
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_4803_11604",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { SmallStar as default };
